import type { TimesheetStatus } from "../types";

export function getTimesheetAvailableActions(status: TimesheetStatus): string[] {
  switch (status) {
    case "draft":
      return ["open", "edit", "approve", "delete"];
    case "approved":
      return ["open", "download"];
    default:
      return ["open"];
  }
}

